import { backdropFor, chapterIndex, domination, hero, nextStoryFight } from "../app.ts";
import { sfx } from "../audio.ts";
import { CHAPTERS } from "../data/story.ts";
import { now, setScene } from "../engine.ts";
import { Actor } from "../render/actor.ts";
import { drawArena, GROUND } from "../render/arena.ts";
import { exhibitionOpponent, SPECIAL_INFO, xpToNext } from "../rules.ts";
import type { SpecialId } from "../types.ts";
import { bar, btn, coin, h, mount } from "../ui/dom.ts";
import { armoryScreen } from "./armory.ts";
import { battleScreen } from "./battle.ts";
import { muteButton, showHelp } from "./common.ts";
import { creatorScreen } from "./creator.ts";
import { titleScreen } from "./title.ts";

export function hubScreen(): void {
  const me = hero();
  const backdrop = backdropFor(me);
  const actor = new Actor(me.look, me.gear, 1, 330);
  setScene((ctx, t) => {
    drawArena(ctx, backdrop, t, 0.2);
    ctx.fillStyle = "rgba(15,8,4,0.25)";
    ctx.fillRect(0, 0, 1280, 720);
    actor.draw(ctx, t, GROUND + 10, 2.6);
  });

  const next = nextStoryFight(me);
  const ch = chapterIndex(me.progress);
  const chapter = CHAPTERS[ch];

  const fightCard = next
    ? h(
        "div",
        { class: "panel next-fight" },
        h("div", { class: "ch" }, `${chapter?.title}: ${chapter?.subtitle}`),
        h(
          "div",
          { class: "pips" },
          ...(chapter?.fights ?? []).map((f, i) =>
            h("div", { class: `pip${f.boss ? " boss" : ""}${ch * 4 + i < me.progress ? " done" : ch * 4 + i === me.progress ? " now" : ""}`, title: f.name }),
          ),
        ),
        h(
          "div",
          { class: "row" },
          h(
            "div",
            { class: "grow" },
            h("h3", null, `${next.opponent.boss ? "👑 " : ""}${next.opponent.name}`),
            h("div", { class: "muted", style: { fontWeight: "800", fontSize: "14px" } }, `Level ${next.opponent.level} · ${next.opponent.title}`),
          ),
          btn("FIGHT!", () => battleScreen({ opponent: next.opponent, backdrop, story: true }), "red big pulse"),
        ),
      )
    : h("div", { class: "panel next-fight" }, h("h3", null, "👑 The World Is Yours"), h("div", { style: { fontWeight: "800" } }, "Every region has fallen. The arena still welcomes challengers, Your Majesty."));

  const menu = h(
    "div",
    { class: "hub-menu" },
    fightCard,
    btn(["🏟️ Exhibition Match", h("span", { class: "sub" }, "Random challenger at your level. Earn gold & XP.")], () =>
      battleScreen({ opponent: exhibitionOpponent(me.level), backdrop: "colosseum", story: false }),
    ),
    btn(["🛡️ The Armory", h("span", { class: "sub" }, "Buy, sell and equip gear.")], armoryScreen, "wood"),
    btn(["📈 Training Grounds", me.points > 0 && h("span", { class: "badge" }, me.points), h("span", { class: "sub" }, "Spend stat points earned from levelling up.")], () => creatorScreen({ mode: "train" }), me.points > 0 ? "green pulse" : "wood"),
    btn(["🪶 Preening Parlor", h("span", { class: "sub" }, "Change your look. Free of charge.")], () => creatorScreen({ mode: "parlor" }), "wood"),
    h("div", { class: "row" }, btn("❓ Help", showHelp, "small wood grow"), btn("🏠 Title", titleScreen, "small wood grow")),
  );

  const xpNeed = xpToNext(me.level);
  const top = h(
    "div",
    { class: "topbar" },
    h(
      "div",
      { class: "panel hero-card" },
      h("div", { class: "lvl", title: "Level" }, me.level),
      h("div", { class: "grow" }, h("h3", null, me.name), bar("xp", me.xp / xpNeed, `XP ${me.xp} / ${xpNeed}`)),
    ),
    h("div", { class: "panel gold" }, coin(), me.gold),
    h(
      "div",
      { class: "panel domination" },
      h("div", { class: "row", style: { justifyContent: "space-between", fontWeight: "900" } }, h("span", null, "🌍 WORLD DOMINATION"), h("span", null, me.finished ? "Supreme Overlord" : (chapter?.region ?? ""))),
      bar("", domination(me) / 100, `${domination(me)}%`),
    ),
  );

  const all: SpecialId[] = ["egg", "roar", "frenzy", "wind"];
  const arts = h(
    "div",
    { class: "arts" },
    ...all.map((id) => {
      const known = me.specials.includes(id);
      return h("div", { class: `art${known ? "" : " locked"}`, title: SPECIAL_INFO[id].desc }, known ? SPECIAL_INFO[id].name : "🔒 ???");
    }),
  );

  const poke = h("div", {
    class: "abs",
    style: { left: "200px", top: "300px", width: "260px", height: "320px", cursor: "pointer" },
    title: `${me.name} W${me.wins}–L${me.losses}`,
    onclick: () => {
      void actor.play(Math.random() < 0.5 ? "taunt" : "roar", now());
      sfx.cluck();
    },
  });

  mount(
    (e) => {
      if (e.key === "Enter" && next) battleScreen({ opponent: next.opponent, backdrop, story: true });
    },
    poke,
    top,
    menu,
    arts,
    muteButton(),
  );
}
